export const PLATFORM = 'mobile';
export const LAQUESIS_PLATFORM = 'm';
export const IS_DESKTOP = false;
export const IS_MOBILE = true;
export const BAXTER_PLATFORM = 'mweb';
